module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-whiteframe', {
    staticClass: "project-box-v2",
    attrs: {
      "md-elevation": "2"
    }
  }, [_c('div', {
    staticClass: "pb-header"
  }, [_c('button', {
    staticClass: "pb-pin",
    class: {
      'is-pinned': _vm.isPinned
    },
    attrs: {
      "type": "button",
      "aria-pressed": _vm.isPinned ? 'true' : 'false',
      "aria-label": _vm.isPinned ? 'Unpin project' : 'Pin project'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.togglePin.apply(null, arguments)
      }
    }
  }, [_c('md-icon', [_vm._v("push_pin")]), _vm._v(" "), _c('md-tooltip', [_vm._v(_vm._s(_vm.isPinned ? 'Unpin' : 'Pin'))])], 1), _vm._v(" "), _c('span', {
    staticClass: "pb-title",
    on: {
      "click": _vm.selectProject
    }
  }, [_vm._v("\n            " + _vm._s(_vm.project.title) + "\n            "), _c('md-tooltip', {
    staticClass: "pb-title-tooltip"
  }, [_vm._v(_vm._s(_vm.project.title))])], 1), _vm._v(" "), _c('dashboard-kebab-menu', {
    ref: "kebab",
    attrs: {
      "project": _vm.project
    },
    on: {
      "projectAccepted": _vm.handleProjectAccepted,
      "projectDeleted": _vm.handleProjectDeleted
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pb-cover",
    on: {
      "click": _vm.selectProject
    }
  }, [(_vm.project.unlocked) ? _c('span', {
    staticClass: "pb-showpass",
    attrs: {
      "title": "Unlocked with a Show Pass"
    }
  }, [_vm._v("Show Pass")]) : (_vm.isLegacy) ? _c('span', {
    staticClass: "pb-legacy",
    class: {
      'is-owner': _vm.isLegacyOwner
    },
    attrs: {
      "title": _vm.legacyTip,
      "aria-label": 'Legacy project. ' + _vm.legacyTip,
      "role": _vm.isLegacyOwner ? 'button' : null,
      "tabindex": _vm.isLegacyOwner ? 0 : null
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onLegacyBadge.apply(null, arguments)
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onLegacyBadge.apply(null, arguments)
      }
    }
  }, [_vm._v("Legacy")]) : _vm._e(), _vm._v(" "), (_vm.hasActiveShowSync) ? _c('span', {
    staticClass: "pb-showsync",
    class: _vm.showSyncStateClass,
    attrs: {
      "title": _vm.showSyncTooltip,
      "aria-label": _vm.showSyncTooltip,
      "role": "img"
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "15",
      "height": "15",
      "aria-hidden": "true",
      "focusable": "false"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M12 4V1L8 5l4 4V6a6 6 0 0 1 5.19 8.99l1.47 1.47A8 8 0 0 0 12 4zm0 14a6 6 0 0 1-5.19-8.99L5.34 7.54A8 8 0 0 0 12 20v3l4-4-4-4v3z"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.hasPoster) ? _c('img', {
    attrs: {
      "src": _vm.project.posterUrl,
      "alt": _vm.project.title
    },
    on: {
      "error": _vm.onPosterError
    }
  }) : _c('div', {
    staticClass: "pb-generated",
    style: ({
      backgroundColor: _vm.coverColor
    })
  }, [_c('span', [_vm._v(_vm._s(_vm.coverInitials))])])]), _vm._v(" "), _c('div', {
    staticClass: "pb-footer",
    on: {
      "click": _vm.selectProject
    }
  }, [_vm._v("\n        Last updated · " + _vm._s(_vm.lastChanged) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29a4b50f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/project-box.vue
// module id = 1219
// module chunks = 21